module.exports = __webpack_public_path__ + "static/btn 2_000022.3faa672c.png";